import { getMostRecentAnalysis } from '@paragon/client-tools';
import { ComponentDesignSealTimestamps, ComponentDesignTimestamps, SealStatus } from '@paragon/contract-library';

import { RootState } from '../slices';
import { ComponentDesignHistory } from '../slices/analysisHistorySlice';

export type SealingInformation =
  | { sealStatus: Extract<SealStatus, 'none'> }
  | { sealStatus: Extract<SealStatus, 'requested' | 'sealed'>; jobId: number; date: Date };

export function computeSealingInformation(
  analyses: ComponentDesignHistory | undefined,
  sealTimestampsRecord: ComponentDesignSealTimestamps | undefined,
  timestampsRecord: ComponentDesignTimestamps | undefined,
): SealingInformation {
  if (!analyses || !sealTimestampsRecord || !timestampsRecord) return { sealStatus: 'none' };

  const mostRecentAnalysis = getMostRecentAnalysis(Object.values(analyses));
  if (
    !mostRecentAnalysis ||
    mostRecentAnalysis.analysisSetGuid !== sealTimestampsRecord.analysisSetGuid ||
    timestampsRecord.lastAnalyzed !== timestampsRecord.lastUpdated
  ) {
    return { sealStatus: 'none' };
  }

  return {
    sealStatus: sealTimestampsRecord.returnedTimestamp ? 'sealed' : 'requested',
    jobId: sealTimestampsRecord.jobId,
    date: new Date(sealTimestampsRecord.returnedTimestamp ?? sealTimestampsRecord.createdTimestamp),
  };
}

export function getSealingInformation(state: RootState, componentDesignGuid: string): SealingInformation {
  return computeSealingInformation(
    state.analysisHistory[componentDesignGuid],
    state.componentDesignSealTimestamps[componentDesignGuid],
    state.componentDesignTimestamps[componentDesignGuid],
  );
}
